export default __webpack_public_path__ + "ccf47665b5124c4a1d984cd905e69a50.png";